const getEnvs = (): { [key: string]: string | undefined } => ({
    API_URL: process.env.REACT_APP_API_URL,
})

export default getEnvs
